<template>
  <section class="site-price">
    <div class="site-price__wrapper">
      <div class="site-price__wrapper__text">
        <h2 class="site-price__wrapper__text__title site-section-title">
          Combien ça coûte?
        </h2>
        <div class="site-price__wrapper__text__subtitle">
          Générez vos CRA gratuitement, sans limite de durée.
        </div>
        <div class="site-price__wrapper__text__subtitle">
          Passez à l'offre Intégration pour le suivi avancé, le reporting et la connexion à vos outils de facturation.
        </div>
      </div>
      <div class="site-price__wrapper__prices">
        <!-- Offre Gratuite -->
        <div class="site-price__wrapper__prices__card">
          <div class="site-price__wrapper__prices__card__title">Essentiel</div>
          <div class="site-price__wrapper__prices__card__price">
            <span class="site-price__wrapper__prices__card__price__amount">0 €</span>
          </div>
          <ul class="site-price__wrapper__prices__card__features">
            <li class="site-price__wrapper__prices__card__features__feature site-price__wrapper__prices__card__features__feature--title">
              CRA
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              CRA mensuel illimité
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Signature électronique
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Validation par le client final
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Export PDF
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Jours fériés automatiques
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Gestion de mission
            </li>
          </ul>
          <div class="site-price__wrapper__prices__card__separator" />
          <div class="site-price__wrapper__prices__card__action">
            <SiteButton
              type="primary"
              label="Créer mon CRA"
              has-arrow
              full-width-mobile
              @click="$router.push({ name: 'app' })"
            />
          </div>
        </div>

        <!-- Offre Intégration -->
        <div class="site-price__wrapper__prices__card site-price__wrapper__prices__card--invert">
          <div class="site-price__wrapper__prices__card__title">Intégration</div>
          <div class="site-price__wrapper__prices__card__price">
            <span class="site-price__wrapper__prices__card__price__amount">4,99 €</span>
            <span class="site-price__wrapper__prices__card__price__per">HT / mois</span>
            <div class="site-price__wrapper__prices__card__pre-action">
              1 mois gratuit
            </div>
          </div>
          <ul class="site-price__wrapper__prices__card__features">
            <li class="site-price__wrapper__prices__card__features__feature site-price__wrapper__prices__card__features__feature--reprise">
              Tout l'Essentiel, plus :
            </li>
            <li class="site-price__wrapper__prices__card__features__feature site-price__wrapper__prices__card__features__feature--title">
              Suivi
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Tableau de bord des CRA (en attente, validés, en retard)
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Notification de validation
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Export CSV / Excel
            </li>
            <li class="site-price__wrapper__prices__card__features__feature site-price__wrapper__prices__card__features__feature--title">
              Intégrations comptables
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Intégration Pennylane
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Intégration Indy
            </li>
            <li class="site-price__wrapper__prices__card__features__feature">
              <check class="site-price__wrapper__prices__card__features__feature__puce" />
              Intégration Tiime
            </li>
          </ul>
          <div class="site-price__wrapper__prices__card__separator" />
          <div class="site-price__wrapper__prices__card__action">
            <SiteButton
              type="primary"
              label="Essayer Intégration"
              has-arrow
              full-width-mobile
              @click="notifyPro"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

  import check from './check.vue'
  import cross from './cross.vue'
  import { ElMessageBox } from 'element-plus'
  import useIdentity from '@/components/SiteIdentity'

  const emit = defineEmits(['signup'])
  const config = useRuntimeConfig()
  const siteIdentity = useIdentity()

  const notifyPro = async () => {
    const email = siteIdentity.identity.value?.email || null

    try {
      await $fetch(`${config.public.apiBaseUrl}/pro-interest`, {
        method: 'POST',
        body: { email }
      }).catch(() => {})
    } catch (e) {}

    ElMessageBox.alert(
      'L\'offre Intégration arrive bientôt ! Nous vous préviendrons dès qu\'elle sera disponible.',
      'Bientôt disponible',
      { confirmButtonText: 'OK', type: 'info' }
    )
  }

</script>

<style lang="scss">

  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  
  .site-price {
    display: flex;
    justify-content: center;
    &__wrapper {
      max-width: 1260px;
      display: flex;
      flex-direction: column;
      margin: 40px 15px;

      @media screen and (min-width: $desktop-breakpoint) {
        flex-direction: row;
        margin: 75px 15px 100px 15px;
      }

      &__text {
        @media screen and (min-width: $tablet-breakpoint) {
          margin: 20px;
        }
        @media screen and (min-width: $desktop-breakpoint) {
          max-width: 30%;
          margin-top: 10%;
          padding-right: 15px;
        }
        @media screen and (min-width: 1100px) {
          max-width: 40%;
        }
        &__title {
          color: #01498B;
          margin-bottom: 20px;

          @media screen and (min-width: $tablet-breakpoint) {
            text-align: center;
          }
          @media screen and (min-width: $desktop-breakpoint) {
            text-align: left;
          }
        }

        &__subtitle {
          font-size: 18px;
          color: #242424;
          line-height: 26px;
          font-weight: 200;
          margin-bottom: 5px;

          @media screen and (min-width: $tablet-breakpoint) {
            text-align: center;
          }
          @media screen and (min-width: $desktop-breakpoint) {
            text-align: left;
          }
        }
      }

      &__prices {
        margin-left: -15px;
        margin-right: -15px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;

        @media screen and (min-width: $desktop-breakpoint) {
          padding-left: 15px;
        }

        @media screen and (min-width: $desktop-breakpoint) {
          margin-left: 0;
          margin-right: 0;
          justify-content: flex-end;
          flex-wrap: nowrap;
        }

        &__card {
          display: flex;
          flex-direction: column;
          margin: 25px 15px 0 15px;
          padding: 30px 20px;
          border-radius: 20px;
          border: solid 2px #01498B;
          max-width: 345px;

          flex-grow: 1;
          flex-shrink: 1;

          @media screen and (min-width: $desktop-breakpoint) {
            width: 50%;
          }

          &__title {
            font-size: 26px;
            color: #01498B;
            margin-bottom: 5px;
          }

          &__price {
            margin-bottom: 30px;
            color: #01498B;
            &__amount {
              font-size: 40px;
              font-weight: 600;
            }

            &__per {
              font-size: 21px;
              font-weight: 200;
            }
          }

          &__features {
            margin: 0;
            padding: 0;
            list-style: none;
            display: flex;
            flex-direction: column;
            &__feature {
              color: #01498B;
              font-size: 18px;
              font-weight: 200;
              margin-bottom: 20px;
              display: inline;
              position: relative;
              margin-left: 32px;

              &--reprise {
                margin-left: 0;
                font-size: 20px;
                font-weight: 400;
                margin-top: -10px;
                margin-bottom: 30px;
              }

              &--title {
                font-weight: 700;
                font-size: 20px;
                display: none;
              }

              &__puce {
                position: absolute;
                left: -32px;
                flex-shrink: 0;
                fill: #01498B;
              }

              span {
                font-size: 12px;
              }
            }
          }

          &__separator {
            flex-grow: 10;
          }

          &__pre-action {
            font-weight: 200;
            color: #01498B;
          }

          &__action {
            margin-top: 10px;

          }


          &--invert {
            background-color: #01498B;
            box-shadow: 0 4px 20px 0 rgb(0 0 0 / 0.2);

            .site-price__wrapper__prices__card {

              &__title {
                color: white;
              }
              &__price {
                color: white;
              }

              &__features {
                &__feature {
                  color: white;
                  &__puce {
                    fill: white;
                  }
                }
              }

              &__pre-action {
                color: white;
              }
            }
          }


        }
      }
    }
  }
</style>